import { Constants } from '../../app.const';

export class ReportsConstants {

    public static basicConstans = Constants;

    public static baseUrl: string = Constants.baseUrl;
    public static apiUrl: string = Constants.baseUrl+Constants.apiVersioning;
    public static appUrl: string = Constants.appUrl;
    public static loginUrl: string = Constants.loginUrl;
    public static imageUrl: string = Constants.imageUrl;
    public static apiVersioning: string = Constants.apiVersioning;
    public static endPoint: string = Constants.endPoint;

    
    public static months=[
        {"id": 1, "name": "January"},
        {"id": 2, "name": "February"},
        {"id": 3, "name": "March"},
        {"id": 4, "name": "April"},
        {"id": 5, "name": "May"},
        {"id": 6, "name": "June"},
        {"id": 7, "name": "July"},
        {"id": 8, "name": "August"},
        {"id": 9, "name": "September"},
        {"id": 10, "name": "October"},
        {"id": 11, "name": "November"},
        {"id": 12, "name": "December"},
    ];
};


// WEBPACK FOOTER //
// ./src/app/modules/reports/reports.const.ts